"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9265],{

/***/ 88452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ GuestsBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./main/javascripts/components/form/SelectBlock.tsx + 2 modules
var SelectBlock = __webpack_require__(82600);
// EXTERNAL MODULE: ./main/javascripts/utils/ArrayUtil.ts
var ArrayUtil = __webpack_require__(77562);
// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/hotel/form/GuestPeopleBlock.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var GuestPeopleBlockComponent = function GuestPeopleBlockComponent(props) {
  var groupName = props.groupName,
      maxNumberOfChildren = props.maxNumberOfChildren,
      maxNumberOfAdult = props.maxNumberOfAdult,
      _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "default" : _props$labelColorStyl,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      errors = props.errors;

  var renderNumberOfChildren = function renderNumberOfChildren() {
    var optionList = []; // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(maxNumberOfChildren + 1).keys()).map(function (childNum) {
      optionList.push((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
        value: childNum,
        children: "".concat(childNum, " \u4EBA")
      }, childNum));
    });
    var fieldName = "".concat(groupName, ".number_of_children");
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: guestInputBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectBlock/* SelectBlock */.w, {
        namespace: "hotel",
        label: {
          namespace: "common",
          label: "子供(0～17歳)",
          colorStyleKey: labelColorStyleKey
        },
        select: {
          name: fieldName,
          children: optionList
        },
        error: (0,index_esm/* get */.U2)(errors, fieldName),
        borderColorStyleKey: borderColorStyleKey
      })
    });
  };

  var renderNumberOfAdult = function renderNumberOfAdult() {
    var optionList = []; // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(maxNumberOfAdult).keys()).map(function (numberOfAdult) {
      optionList.push((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
        value: numberOfAdult + 1,
        children: "".concat(numberOfAdult + 1, " \u4EBA")
      }, numberOfAdult));
    });
    var fieldName = "".concat(groupName, ".number_of_adult");
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: guestInputBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectBlock/* SelectBlock */.w, {
        namespace: "hotel",
        label: {
          namespace: "common",
          label: "大人(18歳以上)",
          colorStyleKey: labelColorStyleKey
        },
        select: {
          name: fieldName,
          children: optionList
        },
        error: (0,index_esm/* get */.U2)(errors, fieldName),
        borderColorStyleKey: borderColorStyleKey
      })
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [renderNumberOfAdult(), renderNumberOfChildren()]
  });
};

var GuestPeopleBlock = /*#__PURE__*/react.memo(GuestPeopleBlockComponent);
var guestInputBlockStyle =  true ? {
  name: "1t29t6p",
  styles: "width:50%"
} : 0;
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/hotel/form/GuestChildrenAgeField.tsx






var GuestChildrenAgeField = function GuestChildrenAgeField(props) {
  var groupName = props.groupName,
      index = props.index,
      maxAgeOfChildren = props.maxAgeOfChildren,
      numberOfRooms = props.numberOfRooms,
      _props$ageInputWidthS = props.ageInputWidthStyle,
      ageInputWidthStyle = _props$ageInputWidthS === void 0 ? "33.333%" : _props$ageInputWidthS,
      borderColorStyleKey = props.borderColorStyleKey,
      errors = props.errors;
  var fieldArrayName = "".concat(groupName, ".ages_of_children");
  var fieldName = "".concat(fieldArrayName, ".").concat(index, ".age");

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var ageValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  });
  (0,react.useEffect)(function () {
    if (ageValue) {
      void trigger(fieldName);
    }
  }, [ageValue]);
  var optionList = [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
    value: "",
    disabled: true,
    children: "\u5E74\u9F62"
  }, "none")];
  var ageInputStyles = Number(numberOfRooms || 1) === 1 ? null : /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:", ageInputWidthStyle, ";}" + ( true ? "" : 0),  true ? "" : 0); // tslint:disable-next-line:prefer-array-literal

  Array.from(Array(maxAgeOfChildren + 1).keys()).map(function (childAge) {
    optionList.push((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
      value: childAge,
      children: "".concat(childAge, " \u6B73")
    }, childAge));
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: [guestInputBlockSmallStyle, ageInputStyles,  true ? "" : 0,  true ? "" : 0],
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectBlock/* SelectBlock */.w, {
      namespace: "hotel",
      label: {
        namespace: "hotel",
        label: "\u304A\u5B50\u69D8 ".concat(Number(index) + 1, "\u306E\u5E74\u9F62"),
        colorStyleKey: "primary"
      },
      select: {
        name: fieldName,
        children: optionList
      },
      error: (0,index_esm/* get */.U2)(errors, fieldName),
      borderColorStyleKey: borderColorStyleKey
    })
  });
};
var guestInputBlockSmallStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:33.333%;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:25%;}" + ( true ? "" : 0),  true ? "" : 0); // const childLabelStyle = css`
//   color: ${accentColor.primaryColor};
//   font-weight: ${fontWeight.regular};
// `;
;// CONCATENATED MODULE: ./main/javascripts/components/hotel/form/GuestChildrenBlock.tsx
function GuestChildrenBlock_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var GuestChildrenBlockComponent = function GuestChildrenBlockComponent(props) {
  var groupName = props.groupName,
      maxAgeOfChildren = props.maxAgeOfChildren,
      numberOfRooms = props.numberOfRooms,
      _props$ageInputWidthS = props.ageInputWidthStyle,
      ageInputWidthStyle = _props$ageInputWidthS === void 0 ? "33.333%" : _props$ageInputWidthS,
      borderColorStyleKey = props.borderColorStyleKey,
      errors = props.errors;
  var fieldArrayName = "".concat(groupName, ".ages_of_children");

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control;

  var _useFieldArray = (0,index_esm/* useFieldArray */.Dq)({
    name: fieldArrayName
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  var numberOfChildrenValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: "".concat(groupName, ".number_of_children")
  }); // useFieldArrayではオブジェクト単位で追加する必要があり
  // indexで終わるkeyに対して値を追加できないため
  // .ageで管理し、リクエスト時に整形する

  (0,react.useEffect)(function () {
    var oldNumberOfChildren = fields.length || 0;
    var newNumberOfChildren = Number(numberOfChildrenValue); // setValue(`guests[${index}].number_of_children`, childNum);

    if (oldNumberOfChildren > newNumberOfChildren) {
      remove((0,ArrayUtil/* rangexy */.w)(newNumberOfChildren, oldNumberOfChildren));
    } else if (oldNumberOfChildren < newNumberOfChildren) {
      (0,ArrayUtil/* rangexy */.w)(oldNumberOfChildren, newNumberOfChildren).map(function (_) {
        append({
          age: ""
        }, {
          shouldFocus: false
        });
      });
    }
  }, [numberOfChildrenValue]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: guestInputGroupBlockStyle,
    children: fields.map(function (field, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestChildrenAgeField, {
        groupName: groupName,
        index: index,
        maxAgeOfChildren: maxAgeOfChildren,
        numberOfRooms: numberOfRooms,
        ageInputWidthStyle: ageInputWidthStyle,
        borderColorStyleKey: borderColorStyleKey,
        errors: errors
      }, field.id);
    })
  });
};

var GuestChildrenBlock = /*#__PURE__*/react.memo(GuestChildrenBlockComponent);
var guestInputGroupBlockStyle =  true ? {
  name: "798ujy",
  styles: "width:100%;display:flex;flex-wrap:wrap"
} : 0;
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/hotel/GuestsBlock.tsx
function GuestsBlock_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var MAX_NUMBER_OF_ROOMS = 8;
var MAX_NUMBER_OF_ADULT = 7;
var MAX_NUMBER_OF_CHILDREN = 7;
var MAX_AGE_OF_CHILDREN = 17;
var initialRoomValue = {
  number_of_adult: 2,
  number_of_children: 0,
  ages_of_children: []
};

var GuestsBlockComponent = function GuestsBlockComponent(props) {
  var labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      _props$isGuestMultipl = props.isGuestMultipleColumn,
      isGuestMultipleColumn = _props$isGuestMultipl === void 0 ? true : _props$isGuestMultipl; // public shouldComponentUpdate(nextProps: any): boolean {
  //   return !isEqual(props, nextProps);
  // }

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors;

  var values = (0,index_esm/* useWatch */.qo)();

  var _useFieldArray = (0,index_esm/* useFieldArray */.Dq)({
    name: "guests"
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  var valuesRef = (0,react.useRef)(values);
  valuesRef.current = values;

  var renderNumberOfRooms = function renderNumberOfRooms() {
    var optionList = []; // const { styles = {} } = props;
    // const { labelStyle } = styles;

    var fieldName = "number_of_rooms"; // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(MAX_NUMBER_OF_ROOMS).keys()).map(function (num) {
      optionList.push((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
        value: num + 1,
        role: "option",
        "aria-selected": num === 0,
        children: "".concat(num + 1, " \u5BA4")
      }, num));
    });
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: [GuestsBlock_guestInputBlockStyle, guestNumBlockStyle,  true ? "" : 0,  true ? "" : 0],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectBlock/* SelectBlock */.w, {
        namespace: "hotel",
        label: {
          namespace: "hotel",
          label: "客室数",
          colorStyleKey: labelColorStyleKey
        },
        select: {
          name: fieldName,
          onChange: onChangeNumberOfRooms,
          children: optionList
        },
        error: (0,index_esm/* get */.U2)(errors, fieldName),
        borderColorStyleKey: borderColorStyleKey
      })
    });
  };

  var onChangeNumberOfRooms = function onChangeNumberOfRooms(e) {
    var oldNumberOfRooms = parseInt(valuesRef.current.number_of_rooms, 10);
    var numberOfRooms = parseInt(e.target.value, 10);
    setValue("number_of_rooms", numberOfRooms);

    if (oldNumberOfRooms > numberOfRooms) {
      remove((0,ArrayUtil/* rangexy */.w)(numberOfRooms, oldNumberOfRooms));
    } else if (oldNumberOfRooms < numberOfRooms) {
      (0,ArrayUtil/* rangexy */.w)(oldNumberOfRooms, numberOfRooms).map(function (_) {
        append(initialRoomValue);
      });
    }
  };

  var renderGuestsFields = function renderGuestsFields() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
      children: fields.map(function (field, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: guestInputGroupBlockMediumStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestPeopleBlock, {
              groupName: "guests.".concat(index),
              maxNumberOfChildren: MAX_NUMBER_OF_CHILDREN,
              maxNumberOfAdult: MAX_NUMBER_OF_ADULT,
              labelColorStyleKey: labelColorStyleKey,
              borderColorStyleKey: borderColorStyleKey,
              errors: errors
            })
          }, "people"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: GuestsBlock_guestInputGroupBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestChildrenBlock, {
              groupName: "guests.".concat(index),
              maxAgeOfChildren: MAX_AGE_OF_CHILDREN,
              numberOfRooms: values.number_of_rooms,
              ageInputWidthStyle: isGuestMultipleColumn ? "25%" : null,
              borderColorStyleKey: borderColorStyleKey,
              errors: errors
            })
          }, "childs")]
        }, field.id);
      })
    }, 0);
  };

  var renderGuestsFieldsWithMulti = function renderGuestsFieldsWithMulti() {
    // const { styles = {} } = props;
    // const { guestItemStyle } = styles;
    var guestInputGroupBlockStyles = isGuestMultipleColumn ? guestInputGroupForMultiBlockStyle : GuestsBlock_guestInputGroupBlockStyle;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
      children: fields.map(function (field, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: guestInputGroupBlockStyles,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: guestLabelStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
              children: ["\u5BA2\u5BA4 ", index + 1]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: guestInputGroupBlockNoWrapStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestPeopleBlock, {
              groupName: "guests.".concat(index),
              maxNumberOfChildren: MAX_NUMBER_OF_CHILDREN,
              maxNumberOfAdult: MAX_NUMBER_OF_ADULT,
              labelColorStyleKey: labelColorStyleKey,
              borderColorStyleKey: borderColorStyleKey,
              errors: errors
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestChildrenBlock, {
            groupName: "guests.".concat(index),
            maxAgeOfChildren: MAX_AGE_OF_CHILDREN,
            numberOfRooms: values.number_of_rooms,
            ageInputWidthStyle: isGuestMultipleColumn ? "33.333%" : null,
            borderColorStyleKey: borderColorStyleKey,
            errors: errors
          })]
        }, field.id);
      })
    }, 0);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: guestBlockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: GuestsBlock_guestInputGroupBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: GuestsBlock_guestInputGroupBlockStyle,
        children: [renderNumberOfRooms(), Number(values.number_of_rooms || 1) === 1 ? renderGuestsFields() : ""]
      })
    }), Number(values.number_of_rooms || 1) > 1 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: multiGuestBlockStyle,
      children: renderGuestsFieldsWithMulti()
    }) : ""]
  });
};

var areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare_default()(prevProps, nextProps);
};

var GuestsBlock = /*#__PURE__*/react.memo(GuestsBlockComponent, areEqual);
var guestBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;padding:", spaceStyle/* space.atom */.D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var guestInputGroupForMultiBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;display:flex;flex-wrap:wrap;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:50%;}" + ( true ? "" : 0),  true ? "" : 0);
var GuestsBlock_guestInputGroupBlockStyle =  true ? {
  name: "798ujy",
  styles: "width:100%;display:flex;flex-wrap:wrap"
} : 0;
var guestInputGroupBlockNoWrapStyle =  true ? {
  name: "35nuew",
  styles: "width:100%;display:flex;flex-wrap:nowrap"
} : 0;
var GuestsBlock_guestInputBlockStyle =  true ? {
  name: "1t29t6p",
  styles: "width:50%"
} : 0;
var guestInputGroupBlockMediumStyle =  true ? {
  name: "do4vze",
  styles: "width:66.666%;display:flex"
} : 0;
var guestNumBlockStyle =  true ? {
  name: "1a3xxfr",
  styles: "width:33.333%"
} : 0; // const guestInputBlockSmallStyle = css`
//   width: 33.333%;
//   ${moreThanBreakpoint("tablet")} {
//     width: 25%;
//   }
// `;
// const childLabelStyle = css`
//   color: ${accentColor.primaryColor};
//   font-weight: ${fontWeight.regular};
// `;

var guestLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:#fff;background-color:", colorStyle/* accentColor.secondaryColor */.z.secondaryColor, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.label */.Nv.label, ";padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom */.D.atom, " 0.2rem;margin:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var multiGuestBlockStyle =  true ? {
  name: "esy9f9",
  styles: "width:100%;display:flex;flex-wrap:wrap;align-items:flex-start"
} : 0;

/***/ }),

/***/ 27114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckinInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckinInput = function CheckinInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkin_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックイン",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ }),

/***/ 82011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckoutInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckoutInput = function CheckoutInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkout_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックアウト",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ })

}]);